import React from 'react'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import {
  IconPane,
  IconWrapper,
  IconsGrid,
  ValueCard,
  ValueText,
  TickPoints,
  TickPoint,
} from './style'
import missionAndValuesItems from './missionAndValuesItems'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'

function WhyWorkForUs() {
  return <Pane type="clear">
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading variant="heading3" align="center" as="h2">
          Our mission and values
        </Heading>
        <BodyText variant="large" as="p" align="center">
          Make people happy by curating and selling the world's best holiday experiences.
        </BodyText>
        <IconsGrid>
          {missionAndValuesItems.map((item) =>
            <IconWrapper key={item.title}>
              <IconPane type="clean">
                <PaneBody size="lg">
                  <ValueCard>
                    <div>{item.icon}</div>
                    <ValueText>
                      <BodyText variant="large" weight="bold">{item.title}</BodyText>
                      <TickPoints>
                        {item.text.map(t =>
                          <TickPoint key={t}>
                            <div><LineCheckIcon colour="primary" /></div>
                            <BodyText variant="medium">{t}</BodyText>
                          </TickPoint>,
                        )}
                      </TickPoints>
                    </ValueText>
                  </ValueCard>
                </PaneBody>
              </IconPane>
            </IconWrapper>,
          )}
        </IconsGrid>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default WhyWorkForUs
